import type * as THREE from "three/webgpu";

/**
 * Ensure gizmo descendants render above viewport overlays.
 *
 * Parent-group renderOrder should cluster descendants, but Edit Mode's
 * transparent overlay mesh can still sort over child drawables that keep the
 * default renderOrder. Stamp a base order onto descendants that haven't opted
 * into a more specific local order.
 */
export function applyGizmoRenderOrder(
  root: THREE.Object3D,
  baseRenderOrder: number,
): void {
  root.renderOrder = Math.max(root.renderOrder, baseRenderOrder);
  root.traverse((child) => {
    if (child !== root && child.renderOrder === 0) {
      child.renderOrder = baseRenderOrder;
    }
  });
}
